var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",staticStyle:{"height":"87%"},attrs:{"id":"token"}},[(_vm.loading)?_c('div',{staticClass:"mt-3 text-center"},[_c('h5',[_vm._v("Veuillez patienter...")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }